import { useState, useEffect } from "react";
import {
    Card,
    Grid,
    Box,
    Typography,
    Button
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import autoTable from "jspdf-autotable";


// Function to handle PDF Download
const downloadPDF = () => {
    const { columns, rows } = authorsTableData();
    const doc = new jsPDF();

    doc.text("लोकशाही दिन अहवाल", 14, 10); // Title
    autoTable(doc, {
        head: [columns.map(col => col.accessor)],
        body: rows.map(row => columns.map(col => row[col.accessor])),
        startY: 20,
        theme: "grid",
    });

    doc.save("Lokshahi_Report.pdf");
};

// Function to handle Excel Download
const downloadExcel = () => {
    const { columns, rows } = authorsTableData();
    const worksheetData = [columns.map(col => col.accessor)]; // Headers

    rows.forEach(row => {
        worksheetData.push(columns.map(col => row[col.accessor])); // Row data
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Lokshahi Report");
    XLSX.writeFile(workbook, "Lokshahi_Report.xlsx");
};
// Table Data Function with Official Data
function authorsTableData() {
    return {
        columns: [
            { Header: "Sr No", accessor: "srNo", align: "center" },
            { Header: "Name Of Office", accessor: "officeName", align: "left" },
            { Header: "File", accessor: "file", align: "center" },
            { Header: "Receipt", accessor: "receipt", align: "center" },
            { Header: "Grand Total", accessor: "grandTotal", align: "center" },
        ],
        rows: [
            { srNo: "1", officeName: "Collector", file: "16", receipt: "76", grandTotal: "92" },
            { srNo: "2", officeName: "Tahsil Ghansawangi", file: "7", receipt: "59", grandTotal: "66" },
            { srNo: "3", officeName: "Tahsil Ambad", file: "14", receipt: "22", grandTotal: "36" },
            { srNo: "4", officeName: "SDO Bhokardan", file: "11", receipt: "17", grandTotal: "28" },
            { srNo: "5", officeName: "Tahsil", file: "21", receipt: "4", grandTotal: "25" },
            { srNo: "6", officeName: "Tahsil Jafarbad", file: "12", receipt: "2", grandTotal: "14" },
            { srNo: "7", officeName: "Tahsil Badanapur", file: "0", receipt: "5", grandTotal: "5" },
            { srNo: "8", officeName: "Tahsil Bhokardan", file: "1", receipt: "4", grandTotal: "5" },
            { srNo: "9", officeName: "Tahsil Partur", file: "2", receipt: "0", grandTotal: "2" },
            { srNo: "10", officeName: "SDO Partur", file: "1", receipt: "0", grandTotal: "1" },
            { srNo: "11", officeName: "SDO", file: "0", receipt: "0", grandTotal: "0" },
            { srNo: "12", officeName: "SDO Ambad", file: "0", receipt: "0", grandTotal: "0" },
            { srNo: "13", officeName: "Tahsil mantha", file: "0", receipt: "1", grandTotal: "1" },
            { srNo: "Grand Total", officeName: "", file: "85", receipt: "190", grandTotal: "275" },
        ],
    };
}

export default function Eoffice() {
    const { columns, rows } = authorsTableData();

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box mt={5} mb={3}>
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={3}
                            px={2}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <MDTypography variant="h4" color="white">
                                e-कार्यालय
                            </MDTypography>
                            <Box>
                                <Button
                                    variant="contained"
                                    onClick={downloadPDF}
                                    sx={{
                                        mr: 1,
                                        backgroundColor: "#fff",
                                        boxShadow: "none",
                                        color: "#1976d2",
                                        '&:hover': { backgroundColor: "#fff", boxShadow: "none" }
                                    }}
                                    startIcon={<PictureAsPdfIcon />}
                                >
                                    Download PDF
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={downloadExcel}
                                    sx={{
                                        backgroundColor: "#fff",
                                        boxShadow: "none",
                                        color: "#388e3c",
                                        '&:hover': { backgroundColor: "#fff", boxShadow: "none" }
                                    }}
                                    startIcon={<InsertDriveFileIcon />}
                                >
                                    Download Excel
                                </Button>
                            </Box>
                        </MDBox>
                        <MDBox pt={3}>
                            <DataTable
                                table={{ columns, rows }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                            />
                        </MDBox>
                    </Card>
                </Grid>
            </Box>
        </DashboardLayout>
    );
}
